
import './tutorial.css';

import angular from 'angular';
import uirouter from 'angular-ui-router';

import menuLayout from '../../directive/menu-layout';
import cms from '../../service/cms';

import routing from './tutorial.routes';
import TutorialController from './tutorial.controller';

export default angular.module('page.tutorial', [
		uirouter,
		menuLayout,
		cms
	])
	.config(routing)
	.controller('TutorialController', TutorialController)
	.name;



// WEBPACK FOOTER //
// ./src/page/tutorial/index.js